import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatherModule } from 'angular-feather';
import { allIcons } from 'angular-feather/icons';
import { AttendanceListComponent } from './attendance-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { PipeModule } from 'src/shared/pipes/pipe.module';


@NgModule({
  declarations: [AttendanceListComponent],
  imports: [
    CommonModule,
        FeatherModule.pick(allIcons),
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatTableModule,
    MatSortModule,
    NgSelectModule,
    MatCardModule,
    NgxDropzoneModule,
    PipeModule,
  ],
  exports: [AttendanceListComponent]
})
export class AttendanceListModule { }
